import Vue from 'vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

/** 复用Element图片预览，仅将浏览器加载失败反馈到文件展示区域。 */
export default Vue.extend({
  name: 'FileImageViewer',
  extends: ElImageViewer,
  methods: {
    /** 不输出签名地址；失败只改变本地展示状态。 */
    handleImgError(event: Event): void {
      const image = event.target as HTMLImageElement;
      image.alt = String(this.$t('common.fileUnavailable'));
      (this as unknown as { loading: boolean }).loading = false;
      this.$emit('file-error', image.getAttribute('src'));
    }
  }
});

/** 将当前页匹配的文件标记为暂不可用；不修改确稿、生产或Layout生成状态。 */
export function markFileUnavailable<T extends object>(
  rows: T[],
  url: string,
  update: (row: T, field: string, status: 30) => void
): void {
  if (!url) {
    return;
  }
  rows.forEach(row => {
    const files = row as Record<string, unknown>;
    ['thumbnails', 'prepressConfirmFile', 'layoutPreview'].forEach(field => {
      if (files[field] === url) {
        update(row, field === 'layoutPreview' ? 'layoutPreviewStatus' : `${field}Status`, 30);
      }
    });
  });
}
